<h2 mat-dialog-title class="dialog-title">
  <span>
    {{ translationService.getDiscontinueProductTitleText() }}
  </span>
  <button
    mat-icon-button
    type="button"
    class="dialog-close-button"
    aria-label="Close"
    (click)="onCancel()"
  >
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  <p class="dialog-description">
    {{ translationService.getDiscontinueProductDescriptionText() }}
  </p>

  <mat-form-field appearance="outline" class="dialog-field">
    <mat-label>
      {{ translationService.getReportingYearLabelText() }}
    </mat-label>
    <input
      matInput
      type="number"
      [(ngModel)]="year"
      [min]="minYear"
      [max]="maxYear"
      placeholder="2025"
    />
    <mat-hint>
      {{ translationService.getReportingYearHintText(minYear, maxYear) }}
    </mat-hint>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">
    {{ translationService.getCancelText() }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="onSave()"
    [disabled]="year === null || year < minYear || year > maxYear"
  >
    {{ translationService.getSaveText() }}
  </button>
</mat-dialog-actions>
